import { Bar, mixins } from 'vue-chartjs';
import DefaultOptions from '../DefaultOptions';

export default Bar.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartOptions'],
  computed: {
    options () {
      return Object.assign({}, DefaultOptions, this.chartOptions);
    },
  },
  mounted () {
    this.renderChart(this.chartData, this.options);
  },
});



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-chart/chart-types/VerticalBarChart.js